export const extraRadios = [
  {
    name: "yes",
    icon: "redeem",
    title: "High Quality Gift Wrapping",
    description:
      "Have your New Reg hand-wrapped in high quality gift wrapping for an extra £5.95",
    price: "5.95",
  },
];

export const deliveryRadiosFactory = ({
  special = "",
  recorded = "",
  standard = "",
  hasPlates = true,
}: {
  special: string;
  recorded: string;
  standard: string;
  hasPlates?: boolean;
}) => [
  {
    value: "special",
    icon: "redeem",
    title: "Special Delivery Guaranteed",
    description: `Royal Mail will deliver your letter or parcels the next working day before 1pm.
      Special Delivery Guaranteed gives you the added security of proof of delivery
      including a signature from the receiver and online tracking.`,
    price: `Only £${special}`,
  },
  {
    value: "recorded",
    icon: "redeem",
    title: "Signed For Delivery",
    description: `Royal Mail aims to deliver your letter or parcels the next working day.
    Signed For gives you proof of delivery.`,
    price: `£${recorded}`,
  },
  {
    value: "standard",
    icon: "redeem",
    title: "Standard Delivery",
    description: `Royal Mail aims to deliver your letters or parcels to their destinations the
    next working day.
    However, this is not a guaranteed service and there is no added security.`,
    price: hasPlates ? `£${standard}` : "FREE",
  },
];

export const transferRadiosFactory = ({
  registration,
}: {
  registration?: string;
}) => [
  {
    value: "none",
    icon: "redeem",
    title: "Self-Assignment",
    description: `I'll transfer ${registration?.replace(
      "+",
      " "
    )} myself and deal with all government forms personally. <br />
      Please Note: For the best customer experience, we highly recommend the Premium
      Transfer Service.`,
    price: "FREE",
  },
  {
    value: "standard",
    icon: "redeem",
    title: "Premium Transfer Service",
    description: `We handle all paperwork & guarantee it's error free or <u>your
    money back!</u><br/>
    Experienced administrators handle all documents and coordinate the legal
    assignment on your behalf.`,
    price: "Only £24.50",
  },
];
